{
  "name": "numara",
  "productName": "Numara",
  "description": "Numara Calculator",
  "version": "7.6.3",
  "author": {
    "name": "Timur Atalay",
    "email": "mail@numara.io",
    "url": "https://numara.io"
  },
  "license": "MIT",
  "homepage": "https://github.com/bornova/numara-calculator",
  "main": "src/electron/main.js",
  "type": "module",
  "scripts": {
    "prebuild": "npm run prettier && npm run lint",
    "build": "node build.js",
    "dist": "npm run build && electron-builder",
    "lint": "eslint .",
    "lint:fix": "eslint --fix .",
    "prettier": "prettier --check .",
    "prettier:fix": "prettier --write .",
    "publish": "npm run build && electron-builder --x64 --arm64 -p always",
    "start": "npm run build && electron .",
    "test": "node --test tests/numara-tests.js",
    "wiki": "node src/misc/wiki.js"
  },
  "devDependencies": {
    "@bornova/colorpicker": "^1.0.1",
    "@bornova/deep-diff": "^1.1.1",
    "@eslint/js": "^10.0.1",
    "@formulajs/formulajs": "^4.6.1",
    "codemirror": "^5.65.21",
    "electron": "^45.0.0",
    "electron-builder": "^26.18.0",
    "esbuild": "^0.28.2",
    "eslint": "^10.13.0",
    "fs-extra": "^11.4.1",
    "function-plot": "^1.26.0",
    "globals": "^17.13.0",
    "lucide": "^1.61.0",
    "luxon": "^3.7.2",
    "mathjs": "^15.2.0",
    "nerdamer-prime": "^1.5.0",
    "prettier": "^3.9.10",
    "uikit": "^3.25.27"
  },
  "dependencies": {
    "electron-log": "^5.4.4",
    "electron-store": "^12.0.0",
    "electron-updater": "^6.8.11"
  }
}
